import { apiClient } from '../services/apiService';
import { API_ROOT } from './constants';

const fetchAssets = (plantUnitKey, sectionSystemKey) => {
  return new Promise((resolve, reject) => {
    apiClient
      .get(`${API_ROOT}/taxonomyassetname/${plantUnitKey}/${sectionSystemKey}`)
      .then((res) => resolve(res.data))
      .catch((err) => console.error(err));
  });
};

export { fetchAssets };
